export default "__VITE_ASSET__DuEWmgZj__"